import React, { Component } from 'react'
import moment from 'moment';

import SearchInput from '../facturotopia/search-input/SearchInput';
import CalendarDateRangePicker from '../facturotopia/calendar-date-range-picker/CalendarDateRangePicker.jsx';

class SearchByDatesAndKeyword extends Component {

  state = {}

  constructor(props) {
    super(props);

    const { from: asFrom, to: asTo } = this.props;

    const from = !!asFrom ? moment(asFrom): moment().subtract(7, 'days');
    const to =  !!asTo ? moment(asTo) : moment();

    this.state = {
      date: [
        from.toDate(),
        to.toDate()
      ]
    }
  }

  handleOnKeywordChange = (keyword) => {
    this.props.onKeywordChange(keyword);
  }

  handleOnSearchClear = () => {
    this.handleOnKeywordChange('');
  }

  handleOnDateChange = (date) => {
    const from = moment(date[0]);
    const to = moment(date[1]);

    this.props.onDateChange({
      page: 1,
      from: from.format('YYYY-MM-DD'),
      to: to.format('yyyy-MM-DD')
    });

    this.setState({ date });
  }

  render() {
    const { date } = this.state;
    const { search = '' } = this.props;

    return (
      <div className="d-flex flex-column flex-sm-row">
        <div className="pr-2 pb-2">
          <CalendarDateRangePicker
            value={ date }
            onDateChange={ this.handleOnDateChange }
          />
        </div>
        <div className="flex-fill search-container">
          <SearchInput
            onKeywordChange={ this.handleOnKeywordChange }
            onClear={ this.handleOnSearchClear }
            value={ search }
          />
        </div>
      </div>
    )
  }
}

export default SearchByDatesAndKeyword;